
// Re-export all subscription-related functionality from the modular structure
export * from './useSubscriptionStatus';
export * from './whatsappVerification';
export * from './types';
export * from './checkoutHelpers';

// Create an alias for useSubscriptionStatus as useSubscription for backwards compatibility
import { useSubscriptionStatus } from './useSubscriptionStatus';
export const useSubscription = useSubscriptionStatus;
